import { INITIATED_REFUNDS, BATCH_REFUNDS, AUTO_REFUNDS } from './constants';

export default {
  [INITIATED_REFUNDS]: {
    TABLE_COLUMNS: [
      {
        key: 'orderId',
        displayName: 'Order ID',
        width: 0.12,
      },
      {
        key: 'refundAmount',
        displayName: 'Refund Amt.',
        width: 0.1,
        align: 'right',
      },
      {
        key: 'orderAmount',
        displayName: 'Order Amt.',
        width: 0.1,
        align: 'right',
      },
      {
        key: 'refundId',
        displayName: 'CF Refund ID',
        width: 0.1,
      },
      {
        key: 'arn',
        displayName: 'Refund ARN',
        width: 0.11,
      },
      {
        key: 'paymentMode',
        displayName: 'Payment Mode',
        width: 0.12,
      },
      {
        key: 'refundSpeed',
        displayName: 'Refund Speed',
        width: 0.09,
      },
      {
        key: 'refundStatus',
        displayName: 'Status',
        width: 0.08,
      },
      {
        key: 'badge',
        displayName: '',
        width: 0.035,
      },
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  [BATCH_REFUNDS]: {
    TABLE_COLUMNS: [
      {
        key: '_id',
        displayName: 'Batch ID',
        width: 0.11,
      },
      {
        key: 'merchantFileName',
        displayName: 'File Name',
        width: 0.1,
      },
      {
        key: 'countSuccessful',
        displayName: 'Refunds Processed',
        width: 0.07,
      },
      {
        key: 'countTotal',
        displayName: 'Records Uploaded',
        width: 0.07,
      },
      {
        key: 'fileStatus',
        displayName: 'Status',
        width: 0.06,
      },
      {
        key: 'batchRefundsCta',
        displayName: '',
        width: 0.03,
      },
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  [AUTO_REFUNDS]: {
    TABLE_COLUMNS: [
      {
        key: 'orderId',
        displayName: 'Order ID',
        width: 0.12,
      },
      {
        key: 'utr',
        displayName: 'Transaction UTR',
        width: 0.12,
      },
      {
        key: 'reversalAmount',
        displayName: 'Refund Amt.',
        width: 0.1,
        align: 'right',
      },
      {
        key: 'orderAmount',
        displayName: 'Order Amt.',
        width: 0.1,
        align: 'right',
      },
      {
        key: 'reversalId',
        displayName: 'CF Refund ID',
        width: 0.1,
      },
      {
        key: 'arn',
        displayName: 'Refund ARN',
        width: 0.11,
      },
      {
        key: 'paymentMode',
        displayName: 'Payment Method',
        width: 0.12,
      },
      {
        key: 'userVisibleStatus',
        displayName: 'Status',
        width: 0.08,
      },
      {
        key: 'badge',
        displayName: '',
        width: 0.035,
      },
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
};
